import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"


const Offcanvas = () => {
  return (
    <>
  {/* start offcanvas */}
  <div
    className="offcanvas offcanvas-offset offcanvas-end support_popup"
    tabIndex={-1}
    id="support_item"
  >
    <div className="offcanvas-header">
      <Link to={all_routes.home14}>
        <ImageWithBasePath
          src="assets/img/logo-14.svg"
          alt="logo"
          className="img-fluid logo"
        />
      </Link>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <i className="isax isax-close-circle" />
      </button>
    </div>
    <div className="offcanvas-body">
      {/* Item 1 */}
      <div className="about-popup-item">
        <h3 className="title">About Doccure</h3>
        <p>
          Modern healthcare platform designed to simplify the way patients
          connect with doctors, clinics &amp; medical services.
        </p>
        <div className="about-img d-flex align-items-center gap-2 justify-content-between">
          <div>
            <ImageWithBasePath
              src="assets/img/banner/about-img-1.jpg"
              alt="about-img-1"
              className="img-fluid"
            />
          </div>
          <div>
            <ImageWithBasePath
              src="assets/img/banner/about-img-2.jpg"
              alt="about-img-1"
              className="img-fluid"
            />
          </div>
          <div>
            <ImageWithBasePath
              src="assets/img/banner/about-img-3.jpg"
              alt="about-img-1"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* Item 3 */}
      <div className="about-popup-item border-0 mb-0">
        <h3 className="title">Contact Information</h3>
        <div className="support-item mb-3">
          <div className="avatar avatar-lg bg-primary rounded-circle">
            <i className="isax isax-messages-3" />
          </div>
          <div>
            <p className="title">General Inquiries</p>
            <h4 className="link">info@example.com</h4>
          </div>
        </div>
        <div className="support-item">
          <div className="avatar avatar-lg bg-primary rounded-circle">
            <i className="isax isax-call-calling" />
          </div>
          <div>
            <p className="title">Emergency Cases</p>
            <h4 className="link">+1 24565 89856</h4>
          </div>
        </div>
      </div>
      {/* Item 3 */}
      <div className="about-popup-item border-0 mb-0 pb-0 d-none">
        <h3 className="title">Follow Us</h3>
        <ul className="d-flex align-items-center gap-2 social-iyem">
          <li>
            <Link to="#" className="social-icon" aria-label="facebook">
              <i className="fa-brands fa-facebook" />
            </Link>
          </li>
          <li>
            <Link to="#" className="social-icon" aria-label="twitter">
              <i className="fa-brands fa-x-twitter" />
            </Link>
          </li>
          <li>
            <Link to="#" className="social-icon" aria-label="instagram">
              <i className="fa-brands fa-instagram" />
            </Link>
          </li>
          <li>
            <Link to="#" className="social-icon" aria-label="linkedin">
              <i className="fa-brands fa-linkedin" />
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/offcanvas-bg.png"
      alt="element"
      className="element-01"
    />
  </div>
  {/* end offcanvas */}
</>

  )
}

export default Offcanvas